





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { RoleId } from '@/enum'
import { MASTER_ROLE } from '@/class/const'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Card
  }
})
export default class RoleView extends Vue {
  @Prop() roleId!: RoleId;

  get role () {
    return MASTER_ROLE[this.roleId]
  }

  get isFirstNightActive (): boolean {
    return this.role.activeIn.firstNight
  }
}
